import styled from 'styled-components/macro'

export const TableHeader = styled.div`
  color: var(--gray-700, #344054);
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  line-height: 20px;
`
